import axios from "./axios";
import { ApiResponse } from "../types/express-data.type";
import {
  BranchCreateRequest,
  BranchOverview,
  BranchReadiness,
  BranchResponse,
  BranchUpdateRequest,
} from "../types/branch.type";

const BRANCHES_PATH = "/branches";
const ROUTES_PATH = "/routes";

/**
 * The branch screens render every write failure inline — a 409 names the fields another
 * branch already holds, or the readiness items a route still lacks — so the global toast
 * is suppressed and so is the page-level 403 redirect: the page stays readable.
 */
const INLINE_ERROR_META = {
  suppressErrorToast: true,
  suppressForbiddenRedirect: true,
};

export const getBranchOverview = () =>
  axios.get<ApiResponse<BranchOverview[]>>(`${BRANCHES_PATH}/overview`);

export const getBranch = (uuid: string) =>
  axios.get<ApiResponse<BranchResponse>>(`${BRANCHES_PATH}/${uuid}`);

export const getBranchReadiness = (uuid: string) =>
  axios.get<ApiResponse<BranchReadiness>>(`${BRANCHES_PATH}/${uuid}/readiness`);

export const createBranch = (body: BranchCreateRequest) =>
  axios.post<ApiResponse<BranchResponse>>(BRANCHES_PATH, body, {
    meta: { successMsg: "สร้างสาขาสำเร็จ", ...INLINE_ERROR_META },
  });

export const updateBranch = (uuid: string, body: BranchUpdateRequest) =>
  axios.patch<ApiResponse<boolean>>(`${BRANCHES_PATH}/${uuid}`, body, {
    meta: { successMsg: "แก้ไขข้อมูลสาขาสำเร็จ", ...INLINE_ERROR_META },
  });

/** "เปิดใช้" — takes a MAIN route out of test mode; the server runs the readiness gate first. */
export const openRoute = (routeUuid: string) =>
  axios.patch<ApiResponse<boolean>>(
    `${ROUTES_PATH}/${routeUuid}`,
    { is_test_mode: false },
    { meta: { successMsg: "เปิดใช้สายสำเร็จ", ...INLINE_ERROR_META } },
  );
